import { render, staticRenderFns } from "./PublicHeader.vue?vue&type=template&id=60e20b6f&scoped=true"
import script from "./PublicHeader.vue?vue&type=script&lang=js"
export * from "./PublicHeader.vue?vue&type=script&lang=js"
import style0 from "./PublicHeader.vue?vue&type=style&index=0&id=60e20b6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e20b6f",
  null
  
)

export default component.exports